import { SquadsCore } from '../../../../core/collections';

export class Squads extends SquadsCore {
	get url() {
		return 'nrl/squads.json';
	}
}

export default Squads;